import { render } from "./Verify.vue?vue&type=template&id=00c4c24a&scoped=true"
import script from "./Verify.vue?vue&type=script&lang=js"
export * from "./Verify.vue?vue&type=script&lang=js"

import "./Verify.vue?vue&type=style&index=0&id=00c4c24a&lang=scss&scoped=true"

import exportComponent from "/home/build/jenkins/workdir/workspace/fast-build/fast-build/67161/vshow-main/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c4c24a"]])

export default __exports__